<template>
  <b-modal
    ref="downloadTemplateModal"
    centered
    title="Pobierz szablon warstwy"
    size="lg"
    :visible="downloadTemplateWindowVisible"
    @hidden="hide"
    @show="onShow"
  >
    <b-form>
      <div class="alert alert-danger" role="alert" v-show="showAlert">
        <strong>Uwaga.</strong> Formularz zawiera błędy.
      </div>
      <div
        class="alert alert-danger"
        role="alert"
        v-show="!hasPermissionTemplatesDownload"
      >
        <strong>Uwaga.</strong> Użytkownik nie ma uprawnień do pobrania szablonu
        warstwy.
      </div>
      <b-form-row
        v-show="dataErrors.fileFormatIsEmpty"
        id="file-format-error-info"
      >
        <b-col offset-md="3" md="7">
          <small class="text-danger">Należy wybrać format pliku.</small>
        </b-col>
      </b-form-row>
      <b-form-group
        horizontal
        :label-cols="3"
        breakpoint="md"
        label="Format pliku"
        label-for="file-format"
      >
        <b-form-select
          v-model="template.fileFormat"
          id="file-format"
          @change="onFileFormatChange()"
          :class="{
            'is-invalid': dataErrors.fileFormatIsEmpty,
            'form-control': true
          }"
        >
          <option :value="null">Wybierz</option>
          <option
            v-for="format in fileFormats"
            :key="format.value"
            :value="format.value"
          >
            {{ format.name }}
          </option>
        </b-form-select>
      </b-form-group>
      <b-form-row
        v-show="dataErrors.templateNameIsEmpty"
        id="template-name-error-info"
      >
        <b-col offset-md="3" md="7">
          <small class="text-danger">Należy wybrać szablon.</small>
        </b-col>
      </b-form-row>
      <b-form-group
        horizontal
        :label-cols="3"
        breakpoint="md"
        label="Nazwa szablonu"
        label-for="template-name"
      >
        <b-form-select
          v-model="template.uuid"
          id="template-name"
          :disabled="locked"
          :class="{
            'is-invalid': dataErrors.templateNameIsEmpty,
            'form-control': true
          }"
        >
          <option :value="null">Wybierz</option>
          <option
            v-for="template in templates"
            :key="template.uuid"
            :value="template.uuid"
          >
            {{ template.nazwa }}
          </option>
        </b-form-select>
      </b-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn variant="primary" @click="downloadTemplate">Pobierz</b-btn>
      <b-btn variant="outline-secondary" @click="hide">Anuluj</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { WINDOW_DOWNLOAD_TEMPLATE_HIDE } from '../store/mutations.type';
import { Api as ApiSzablonyWarstw } from '../api/api-szablony-warstw.js';
import SettingsInstance from '../api/SettingsInstance';

export default {
  name: 'DownloadTemplateWindow',
  data: function() {
    return {
      template: {
        uuid: null,
        fileFormat: null
      },
      dataErrors: {
        templateNameIsEmpty: false,
        fileFormatIsEmpty: false
      },
      templates: [],
      locked: true,
      showAlert: false,
      fileFormats: [
        {
          name: 'Shapefile',
          value: 'ESRI Shapefile'
        },
        {
          name: 'GML',
          value: 'GML'
        },
        {
          name: 'GeoJSON',
          value: 'GeoJSON'
        },
        {
          name: 'GPKG',
          value: 'GPKG'
        },
        {
          name: 'CSV',
          value: 'CSV'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['downloadTemplateWindowVisible']),
    hasPermissionTemplatesDownload() {
      return this.hasPermission('Templates_download');
    }
  },
  methods: {
    downloadTemplate(e) {
      e.preventDefault();

      if (this.locked) {
        return;
      }
      if (
        this.validateDownloadTemplateData() &&
        this.hasPermissionTemplatesDownload
      ) {
        this.locked = true;
        const api = new ApiSzablonyWarstw();

        let baseUrl = SettingsInstance.baseApiUrl.trim('/');
        switch (this.template.fileFormat) {
          case 'CSV':
            baseUrl += '/szablony_warstw/csv/download/' + this.template.uuid;
            break;
          default:
            baseUrl +=
              '/szablony_warstw/download/' +
              this.template.uuid +
              '?format_pliku=' +
              encodeURIComponent(this.template.fileFormat);
            break;
        }
        window.location = baseUrl;
        this.hide();
        this.locked = false;
      }
    },
    hide() {
      this.$store.commit(WINDOW_DOWNLOAD_TEMPLATE_HIDE);
    },
    clearModalData() {
      this.locked = true;
      this.showAlert = false;
      for (var error in this.dataErrors) {
        this.dataErrors[error] = false;
      }
      this.templates = [];
      this.template.uuid = null;
      this.template.fileFormat = null;
    },
    onShow() {
      this.clearModalData();
    },
    validateDownloadTemplateData() {
      this.showAlert = false;
      this.dataErrors.templateNameIsEmpty = !this.template.uuid;
      this.dataErrors.fileFormatIsEmpty = !this.template.fileFormat;

      for (var error in this.dataErrors) {
        if (this.dataErrors[error]) {
          this.showAlert = true;
          break;
        }
      }

      return !this.showAlert;
    },
    onFileFormatChange() {
      switch (this.template.fileFormat) {
        case 'CSV':
          this.getCsvTemplates();
          break;
        case null:
          break;
        default:
          this.getOtherTemplates();
          break;
      }
    },
    getCsvTemplates() {
      this.locked = true;
      const api = new ApiSzablonyWarstw();
      let self = this;
      let control = new Date().getTime().toString();
      api
        .getSzablonyWarstwCsv({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
          control: control
        })
        .then(function(response) {
          if (control === response.body.control) {
            self.templates = response.body.szablony_warstw.map(x => {
              return {
                id: x.id,
                nazwa: x.nazwa,
                uuid: x.id
              };
            });
          }
        })
        .catch(function(err) {})
        .finally(function() {
          self.locked = false;
        });
    },
    getOtherTemplates() {
      this.locked = true;
      const api = new ApiSzablonyWarstw();
      let self = this;
      let control = new Date().getTime().toString();
      api
        .getSzablonyWarstw({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
          control: control,
          order_by: 'typ_geometrii'
        })
        .then(function(response) {
          if (control === response.body.control) {
            self.templates = response.body.szablony_warstw;
          }
        })
        .catch(function(err) {})
        .finally(function() {
          self.locked = false;
        });
    }
  }
};
</script>
